import { CisData } from './../models/apis/batchCisApi';
// import {PromotionInstance, ContentInstance, PicColectionIns} from '../models/apis/batchCisApi';
import { fixArticleUrl } from './urlUtils';
export const cisItemsWasher = (batchItems: any[]): CisData[] => {
  if(!batchItems.length) {
    return [];
  }
  let result:any = [];
  let isFeed = true;
  const batchResult = batchItems.map((item: any) => {
    const {
      resourceType,
      resourceData,
    } = item;
    switch (resourceType) {
      case 1:
        result = contentWasher(resourceData);
      break;
      case 2:
        result = promotionWasher(resourceData);
      break;
      case 3:
        result = {
          ...resourceData,
          resourceType: 3,
        };
      break;
      case 4:
        result = resourceData.data.content;
        isFeed = false;
    }
    return result;
  });
  return isFeed ? batchResult : result;
};

const contentWasher = (item:any) => {
  let result:any = {};
  if(item.businessType === 52 || item.businessType === 53) {
    result = {...item.outlinkData, title: item.outlinkData.displayTitle, brief: item.outlinkData.mobileTitle, images: [item.outlinkData.cover]};
  } else {
    result = {...item.contentData};
    if(result.url) {
      result.url = fixArticleUrl(result.url);
    }
  }

  result.resourceType = 1;
  result.contentType = item.contentType;
  result.businessType = item.businessType;
  return result;
};

const promotionWasher =(item:any) => {
  const temp = {};
  return {
    pcm: item.pcm,
    ...item.promoData,
    ...temp,
  };
};



// WEBPACK FOOTER //
// ./src/utils/cisItemsWasher.ts